module.exports = __webpack_public_path__ + "static/media/Aguat-Happy-Blink.9c83a133.png";